// Add API URL from environment variables
const API_URL = process.env.REACT_APP_API;

const getAiConfig = async (configKey) => {
  try {
    const response = await fetch(`${API_URL}/configs`, {
      method: 'GET', 
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${document.cookie.split(';').find(c => c.trim().startsWith('jwt=')).split('=')[1]}`
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    const aiConfig = data.configuration.find(config => config.label === 'ai_config');
    
    if (!aiConfig || !aiConfig.value) {
      throw new Error('AI configuration not found');
    }

    const configArray = JSON.parse(aiConfig.value);
    const specificConfig = configArray.find(config => config.key === configKey);
    
    if (!specificConfig) {
      throw new Error(`Configuration not found for key: ${configKey}`);
    }

    return specificConfig;
  } catch (error) {
    console.error('Error fetching AI configuration:', error);
    throw error;
  }
};

const fetchAiRecommend = async (content_post, configKey) => {
  try {
    const aiConfig = await getAiConfig(configKey);
    
    const payload = {
      max_tokens: aiConfig && aiConfig.max_tokens ? aiConfig.max_tokens : 10000,
      messages: [
        {
          role: 'system',
          content: aiConfig && aiConfig.prompt ? aiConfig.prompt : ''
        },
        {
          role: 'user',
          content: JSON.stringify(content_post)
        }
      ],
      model: aiConfig && aiConfig.model ? aiConfig.model : aiConfig.models[1],
      temperature: aiConfig && aiConfig.temperature ? aiConfig.temperature : 0.8,
      stream: false
    };

    const response = await fetch(aiConfig.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${aiConfig.token}`
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      console.error(`HTTP error! status: ${response.status}`);
      return {
        items: [],
        error: `HTTP error! status: ${response.status}`
      };
    }

    const data = await response.json();
    let content = data.choices[0].message.content;
    let contentParse;
    const match = content.match(/```json\s*([\s\S]*?)\s*```/);
    if (match) {
      content = match[1]; 
      contentParse = JSON.parse(match[1]);
    } else {
      return JSON.parse(content)
    }
    return contentParse;

  } catch (error) {
    console.error('Error fetching AI recommendation:', error);
    throw error;
  }
};

export default fetchAiRecommend; 